import { IFormInput } from "global-states";
import { emailValidation, PhoneFormatter, phoneValidation } from "utils";
import { ISignInScreen } from "./stores";



export const SIGNIN_TAB_OPTIONS = [
  {
    label: "Mobile Number",
    value: "phone",
  },
  {
    label: "Email",
    value: "email",
  },
];

export const SIGNIN_SCREENS: ISignInScreen = {
  LOADING: "loading",
  METHODS: "methods",
  APPROVAL: "approval",
  SIGNIN: "signin",
};

export const SIGNIN_FORM: IFormInput[] = [
  {
    label: "Mobile Number",
    name: "phone",
    placeholder: "",
    type: "input",
    isCountryCodeVisible: true,
    inputType: "text",
    errorMessage: "Please fix length",
    countryCode: "+91",
    value: "",
    validation: (str: string) => {
      return phoneValidation(str);
    },
    formatter: (data: { value: string; countryCode: string }) => {
      const phoneFormatter = new PhoneFormatter();
      const formattedPhone = phoneFormatter.formatPhone(
        data.value,
        data.countryCode
      );
      return {
        formatted: formattedPhone ?? data.value,
        ...data,
        validationInput: formattedPhone?.replace(/\D/g, "") ?? data.value,
      };
    },
  },
  {
    label:  "Email",
    name: "email",
    placeholder: "",
    inputType: "text",
    errorMessage: "Please fix length",
    value: "",
    type: "input",
    validation: (str: string) => {
      return emailValidation(str);
    },
  },
];

export const SIGNIN_METHODS_OPTIONS = [
  {
    label: "Device passkey",
    value: "devicePasskey",
    icon: "ri-fingerprint-line",
  },
  {
    label: "One time password : Phone or Email ",
    value: "otp",
    icon: "ri-smartphone-line",
  },
  {
    label: "Simplici Biometric",
    value: "simpliciBiometric",
    icon: "ri-user-smile-line",
  },
];
